export const truncateString = (str: string, num: number) => {
  if (str && str.length <= num) {
    return str;
  }
  return `${str.slice(0, num)}...`;
};
